import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  compact?: boolean;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  compact = false,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center",
        compact ? "py-10" : "py-16",
        className
      )}
    >
      <div
        className={cn(
          "flex items-center justify-center rounded-xl bg-slate-100/80",
          compact ? "mb-3 h-12 w-12" : "mb-4 h-14 w-14"
        )}
      >
        {icon}
      </div>
      <h3
        className={cn(
          "font-heading font-semibold text-slate-900",
          compact ? "text-sm" : "text-base"
        )}
      >
        {title}
      </h3>
      {description && (
        <p
          className={cn("mx-auto mt-1.5 max-w-xs text-slate-500", compact ? "text-xs" : "text-sm")}
        >
          {description}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
